import type { AccountSummary } from '@fruitful/types';

import { requestBuilder } from '../../../../http/RequestBuilder';
import { useRefetchHolisticSummaryMutationOptions } from '../useRefetchHolisticSummaryMutationOptions';

interface UpsertSyncteraAccountBody {
    id: string;
    name?: string;
    holisticCategory?: string;
    isHidden?: boolean;
}

const useUpsertSyncteraAccount = requestBuilder.mutation<
    AccountSummary,
    UpsertSyncteraAccountBody
>({
    endpoint: '/api/admin/holistic/accounts/synctera',
    method: 'POST',
});

export const useUpsertSyncteraAccountAndRefetch = (
    membershipId: string | null,
) => {
    const refetchHolisticSummaryMutationOptions =
        useRefetchHolisticSummaryMutationOptions(membershipId);

    const { mutateAsync } = useUpsertSyncteraAccount(
        refetchHolisticSummaryMutationOptions,
    );

    const upsertSyncteraAccountAsync = async (
        body: UpsertSyncteraAccountBody,
    ) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        upsertSyncteraAccountAsync,
    };
};
